import { render, staticRenderFns } from "./PlanBook.vue?vue&type=template&id=f86639aa&scoped=true"
import script from "./PlanBook.vue?vue&type=script&lang=js"
export * from "./PlanBook.vue?vue&type=script&lang=js"
import style0 from "./PlanBook.vue?vue&type=style&index=0&id=f86639aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86639aa",
  null
  
)

export default component.exports